




import { defineComponent, onMounted, ref } from "@vue/composition-api";
import { getManagerProviders } from "@/lib/api";
import { loginToken } from "@/lib/loginHelpers";
import BasePage from "@/components/BasePage";

export default defineComponent({
  name: "PageLoginToken",
  components: { BasePage },
  props: {
    token: { type: String, required: true },
  },
  setup(props, { root }) {
    const loading = ref(false);
    const managerProviders = getManagerProviders();

    onMounted(async () => {
      try {
        loading.value = true;
        await managerProviders.providers.LoginProvider.setLongLiveToken("");
        await loginToken(props.token);
        root.$router.push({ name: "home" }).then(() => location.reload());
      } finally {
        loading.value = false;
      }
    });

    return { loading };
  },
});
